import script from "./AddPages.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPages.vue?vue&type=script&setup=true&lang=js"

import "./AddPages.vue?vue&type=style&index=0&id=1816cb82&lang=css"
import "./AddPages.vue?vue&type=style&index=1&id=1816cb82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1816cb82"]])

export default __exports__